/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x5e7f2d from'./sessioncollection.js';export default class Sessions{static async['getConnectedSessions'](_0x1ef8b8,_0x297f0c,_0x5b40f3){const _0x3e872d=new _0x5e7f2d(_0x297f0c,_0x5b40f3);return await _0x3e872d['connect'](_0x1ef8b8),_0x3e872d;}}